import { createContext, useContext } from "react";
import { Integrations } from "@/types/pocketbase-types";

export interface Integration {
  id: string;
  brand: string;
  category: string;
  type: string;
  credentials: object | null;
  settings: object | null;
  status: string;
  created: string;
  updated: string;
}

export interface IntegrationsContextType {
  isLoading: boolean;
  error: Error | null;
  integrations: Integrations[];
  refreshIntegrations: () => Promise<void>;
  getIntegrationsByCategory: (category: string) => Integrations[];
  getIntegrationsByType: (type: string) => Integrations[];
  getActiveIntegrations: () => Integrations[];
}

export const IntegrationsContext = createContext<IntegrationsContextType | undefined>(undefined);

export const useIntegrations = () => {
  const context = useContext(IntegrationsContext);
  if (context === undefined) {
    throw new Error("useIntegrations must be used within an IntegrationsProvider");
  }
  return context;
};